import { GetStaticProps } from "next";

import { fetchLoyaltyProducts } from "../../../api/account/theClub/fetchLoyaltyProducts";
import { getFidelityPageTranslations } from "../../../api/translations/fidelity";
import { LoyaltyProduct } from "../../../api/types/account.type";
import { FidelityTranslations } from "../../../api/types/translations";
import LeClub from "../../../components/Club";
import Header from "../../../components/layout/Header";

interface Props {
  translations?: FidelityTranslations[];
  products?: LoyaltyProduct[];
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  const translations = await getFidelityPageTranslations("en");

  const products = await fetchLoyaltyProducts();
  if (products.success && products.data) {
    products.data.forEach((product) =>
      product.categories.forEach((category) =>
        category.ingredients.forEach((ing) => {
          ing.price = 0;
          ing.premium_price = 0;
        })
      )
    );
  }

  return {
    props: { translations: translations.data, products: products.data },
  };
};

const ClubPage = ({ translations, products }: Props) => {
  return (
    <Header
      title="EatSalad - The Fidelity"
      description="Salade sur mesure à emporter et en livraison | Eat Salad"
      noindex={false}
      nofollow={false}
    >
      {translations && products ? (
        <LeClub translations={translations} products={products} />
      ) : (
        <></>
      )}
    </Header>
  );
};

export default ClubPage;
